import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса журналов C4b через Gateway: инциденты продаж и возвратов места,
 * доказательство восстановления продажи, расхождения журнала чеков. rid —
 * сегмент пути каждого запроса (D-064).
 */
const resource = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}`

export const AQSI_INCIDENT_URLS = {
  incidents: (resourceId: string) => `${resource(resourceId)}/sales/incidents`,
  recoveryProof: (resourceId: string, saleId: string) =>
    `${resource(resourceId)}/sales/${encodeURIComponent(saleId)}/recovery-proof`,
  discrepancies: (resourceId: string) => `${resource(resourceId)}/receipts/discrepancies`,
} as const
